import { render } from "./SidenavCollapse.vue?vue&type=template&id=0f577346&scoped=true"
import script from "./SidenavCollapse.vue?vue&type=script&lang=js"
export * from "./SidenavCollapse.vue?vue&type=script&lang=js"

import "./SidenavCollapse.vue?vue&type=style&index=0&id=0f577346&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f577346"]])

export default __exports__